import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Platform } from '@ionic/angular';
import { VhViethasWebAPPEndUser } from 'vhwebapp';
import { Meta, Title } from '@angular/platform-browser';
import path from '../../config/path/path.json'
@Component({
  selector: 'app-webapp-categories-c001-user',
  templateUrl: './webapp-categories-c001-user.component.html',
  styleUrls: ['./webapp-categories-c001-user.component.scss']
})
export class WebappCategoriesC001UserComponent implements OnInit {
  @Input() category: any;
  isMobile: boolean;
  listFillter: any = [];
  isLoading: boolean = false
  id_field: any
  constructor(
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    public platform: Platform,
    private vhViethasWebAPPEndUser: VhViethasWebAPPEndUser,
    public titleService: Title,
    public metaTagService: Meta
  ) {
    if (this.platform.is("desktop")) this.isMobile = false
    else this.isMobile = true
    this.route.params.subscribe(routeParams => {
      this.id_field = routeParams.id_field
    });
  }

  ngOnInit(): void {
    // console.log(this.category)
    // if (this.category) this.getCategory()
  }
  ngOnChanges() {
    // console.log(this.category)
    this.getCategory()
  }

  getCategory() {
    this.isLoading = true
    this.vhViethasWebAPPEndUser.getComponentContentsByFields('webapp_fields_c001_categorys', { id_webapp_fields_c001: { $eq: this.id_field }, status: { $eq: true } }, {}, {}, 0, 0)
      .then((response: any) => {
        if (response.vcode === 0) {
          //-----------your code-----------
          this.listFillter = response.data
          this.isLoading = false
        }
      }, error => {
        this.isLoading = false
        console.log('error', error)
      })
  }
  checkActiveChildItem(_idChild, _idParent) {
    let valueParamCurrent;
    let valueParamCurrentCategory;
    this.route.params.subscribe(routeParams => {
      valueParamCurrent = routeParams.id_sub_category;
      valueParamCurrentCategory = routeParams.id_category
    });
    if (valueParamCurrent == _idChild && valueParamCurrentCategory == _idParent) {
      return true;
    }
    return false;
  }
  checkAcitveItem(_value) {
    let list: any = [];
    if (this.location.path().length > 0) {
      list = this.location.path().split("/");
      if (list[3] == _value) {
        return true;
      }
    }
    return false;
  }

  gotoCategory(field, category) {
    this.router.navigateByUrl(path.link + '/' + field + "/" + category + "/" + '1')
  }
  gotoSubCategory(field, category, sub) {
    this.router.navigateByUrl(path.link + '/' + field + "/" + category + "/" + sub + "/" + '1')
  }
  gotoHome(home) {
    this.router.navigateByUrl(path.link + '/' + home)
  }

}
